import { createFileRoute } from '@tanstack/react-router';
import { HelpHomePage } from '@/pages/help';
import { helpSearchSchema } from '@/content/help/search-schema';

export const Route = createFileRoute('/protected/_layout/help/')({
  validateSearch: helpSearchSchema,
  component: HelpHomeIndexRoute,
});

function HelpHomeIndexRoute() {
  const search = Route.useSearch();

  return (
    <HelpHomePage
      query={search.q ?? undefined}
      category={search.category ?? undefined}
    />
  );
}
